import { MayNull } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import useMakeLeaderboard from '@src/deserialize/hook/useMakeLeaderboard'
import graphql from '@src/graphql/query/getBattleDemoSoloPvELeaderboard'
import { BattleDemoSoloPvELeaderboard } from '@src/types/battleDemo'
import { useCallback, useState } from 'react'

const useGetBattleDemoSoloPvELeaderboard = (): Hook => {
  const [doFetch, { loading }] = useLazyQuery(graphql)

  const { makeSoloPvELeaderboard } = useMakeLeaderboard()

  const [data, setData] = useState<MayNull<BattleDemoSoloPvELeaderboard>>(null)

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const { first, season, offset } = request

      const variables = {
        input: {
          first,
          leaderboardKey: season,
          offset
        }
      }

      const response = await doFetch({
        variables
      })

      const leaderboardData = makeSoloPvELeaderboard(
        first,
        offset,
        response.data.getDungeonLeaderboard
      )

      setData(leaderboardData)

      return { data: leaderboardData }
    },
    [doFetch, makeSoloPvELeaderboard]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Request = {
  first: number
  season: string
  offset: number
}

type Response = {
  data: MayNull<BattleDemoSoloPvELeaderboard>
}

type Hook = {
  data: MayNull<BattleDemoSoloPvELeaderboard>
  loading: boolean
  fetch: (request: Request) => Promise<Response>
}

export default useGetBattleDemoSoloPvELeaderboard
